import React from 'react';
import PropTypes from 'prop-types';

const ErrorIcon = ({ size = 18, color = '#D62828' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 18 18" fill="none">
    <g>
      <rect fill={color} x="3.6" y="8.1" width="10.8" height="1.8" />
      <path fill={color} d="M9,0C4.1,0,0,4.1,0,9s4.1,9,9,9s9-4,9-9S14,0,9,0z M9,16.7c-4.3,0-7.7-3.4-7.7-7.7S4.7,1.3,9,1.3s7.7,3.4,7.7,7.7S13.3,16.7,9,16.7z" />
    </g>
  </svg>
);

ErrorIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default ErrorIcon;
